<mat-dialog-content>
        <div class="d-flex justify-content-between">
                <h5 class="fw-semibold">Wetterdatendetails </h5>
                <div class="d-flex">
                         <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg"
                                alt="close-modal-icon" (click)="onCloseClicked()">
                </div>
        </div>
        <div class="d-flex flex-column p-2">
                <div *ngFor="let displayValue of displayValues"
                        class="w-100 d-flex justify-content-between align-items-center">
                        <span class="d-flex align-items-center">
                                <img class="me-2" height="20" [src]="displayValue.iconPath"
                                        [alt]="'Icon ' + displayValue.label"
                                        [ngStyle]="{'transform': displayValue.iconTransform}">
                                {{ displayValue.label }}:
                        </span>
                        <span class="ms-4"> {{ displayValue.value }}</span>
                </div>
                <div *ngIf="dataDataTime" class="w-100 d-flex justify-content-between"> <span> Letzte
                                Messung: </span>
                        <span> {{ dataDataTime | date: 'dd.MM.yyyy H:mm' }}</span>
                </div>
                <div *ngIf="!isLoading && displayValues.length === 0" class="text-secondary mt-2">
                        Keine Wetterdaten vorhanden
                </div>
        </div>
</mat-dialog-content>
